import { render } from "./AllModals.vue?vue&type=template&id=ca374972"
import script from "./AllModals.vue?vue&type=script&lang=js"
export * from "./AllModals.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__